export enum PaymentStatus {
  Draft = 'draft',
  Pending = 'pending',
  Successful = 'successful',
  Failed = 'failed',
  Cancelled = 'cancelled',
}
